<template>
  <div>
    <section class="bg-green" style="padding: 40px 0;">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 text-center div-header2">
            <h1 class="text-white">Feeding Program</h1>
            <div class="subheader-white">
              <p class="font18">Pigs need different levels of protein, energy, and nutrition at different stages or weights. Feedpro has specific products that suit each growth stage of the pig.</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="div-panel-2">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 div-probiotic text-center div-header3">
            <h2>Basic Feeding Guide</h2>
            <p>Follow this simple guide to estimate how much feed you need for a typical grow-out cycle.</p>
          </div>
        </div>
        <div class="row margtop-70" style="padding-top: 40px">
          <div class="col-lg-3 col-md-6 col-sm-12 div-image2">
            <img :src="`${state.root_url}/images/pig-1.png`" class="img-pig" />
            <h4>Pre-Starter</h4>
            <p>1 Bag (25 kg)</p>
            <img :src="`${state.root_url}/images/sack-1.png`" class="img-sack" />
          </div>
          <div class="col-lg-3 col-md-6 col-sm-12 div-image2">
            <img :src="`${state.root_url}/images/pig-2.png`" class="img-pig" />
            <h4>Starter</h4>
            <p>1 Bag (50 kg)</p>
            <img :src="`${state.root_url}/images/sack-2.png`" class="img-sack" />
          </div>
          <div class="col-lg-3 col-md-6 col-sm-12 div-image2">
            <img :src="`${state.root_url}/images/pig-3.png`" class="img-pig" />
            <h4>Grower</h4>
            <p>2 Bags (100 kg)</p>
            <img :src="`${state.root_url}/images/sack-3.png`" class="img-sack" />
          </div>
          <div class="col-lg-3 col-md-6 col-sm-12 div-image2">
            <img :src="`${state.root_url}/images/pig-4.png`" class="img-pig" />
            <h4>Finisher</h4>
            <p>0.5 Bag (25 kg)</p>
            <img :src="`${state.root_url}/images/sack-4.png`" class="img-sack" />
          </div>
        </div>
      </div>
    </section>

    <section class="bg-green row-panel2" style="padding-bottom: 50px;">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 div-probiotic div-switching">
            <div class="div-header2">
              <h2 class="font48">Switching Feeds</h2>
              <p>
                When a pig reaches the target weight of the next growth stage, it is necessary to change feed type as well. To avoid digestive problems and upsetting the normal feeding behavior of pigs, switching feed must be done gradually
                over a period of 3 days or recommended by a technician.
              </p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-3 col-md-3 col-sm-12 div-image2">
            <img :src="`${state.root_url}/images/switching-1.png`" class="img-switch" />
            <h5>
              75% - OLD FEED<br />
              25% - NEW FEED
            </h5>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-12 div-image2">
            <img :src="`${state.root_url}/images/switching-2.png`" class="img-switch" />
            <h5>
              50% - OLD FEED<br />
              50% - NEW FEED
            </h5>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-12 div-image2">
            <img :src="`${state.root_url}/images/switching-3.png`" class="img-switch" />
            <h5>
              25% - OLD FEED<br />
              75% - NEW FEED
            </h5>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-12 div-image2">
            <img :src="`${state.root_url}/images/switching-4.png`" class="img-switch" />
            <h5>100% - NEW FEED</h5>
          </div>
        </div>
      </div>
    </section>

    <section class="div-panel-2">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 div-probiotic div-switching">
            <div class="div-header3">
              <h2>Speciﬁc Feeding Programs</h2>
              <p>
                Feedpro products and feeding program differ in their protein and energy levels. For growing to finishing pigs, choose the feeding program that will fit your target harvest date and budget. Please note, these are guides only and
                actual target market weight may be achieved earlier or later.
              </p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-3 col-md-6 col-sm-12">
            <div class="div-feed">
              <img :src="`${state.root_url}/images/feeding-1.png`" class="img-switch" />
              <h4>Super Premium</h4>
              <p>Target market weight is achieved as early as 131 days old</p>
              <p><a href="https://pronatural-storage.s3.ap-southeast-1.amazonaws.com/feedpro/downloadable/Super_Premium_Program.pdf" class="button-primary button-sm" target="_blank">VIEW</a></p>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 col-sm-12">
            <div class="div-feed">
              <img :src="`${state.root_url}/images/feeding-2.png`" class="img-switch" />
              <h4>Premium</h4>
              <p>Target market weight is achieved as early as 146 days old</p>
              <p><a href="https://pronatural-storage.s3.ap-southeast-1.amazonaws.com/feedpro/downloadable/Premium_Program.pdf" class="button-primary button-sm" target="_blank">VIEW</a></p>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 col-sm-12">
            <div class="div-feed">
              <img :src="`${state.root_url}/images/feeding-3.png`" class="img-switch" />
              <h4>Ecopro</h4>
              <p>Target market weight is achieved as early as 153 days old</p>
              <p><a href="https://pronatural-storage.s3.ap-southeast-1.amazonaws.com/feedpro/downloadable/Ecopro_Program.pdf" class="button-primary button-sm" target="_blank">VIEW</a></p>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 col-sm-12">
            <div class="div-feed">
              <img :src="`${state.root_url}/images/feeding-4.png`" class="img-switch" />
              <h4>Breeder</h4>
              <p>For lactating and gestating sows</p>
              <p class="eco-p"><a href="https://pronatural-storage.s3.ap-southeast-1.amazonaws.com/feedpro/downloadable/Breeder_Program.pdf" class="button-primary button-sm" target="_blank">VIEW</a></p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section-video div-panel-2">
      <div class="container">
        <div class="row">
          <div class="col-lg-6 col-md-6 col-sm-12 div-subheader feedpro-flex" style="height: auto;">
            <div>
              <h2>FeedproTV Feature</h2>
              <h4 class="roboto400">Guide to more efficient and economical feeding</h4>
              <p>Do you know how much of feed is wasted because of incorrect feeding methods? Watch this episode to know how you can save on feeds by improving your feeding management.</p>
            </div>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12 div-youtube">
            <iframe 
              width="100%" 
              height="280" 
              src="https://www.youtube.com/embed/yGKcZUr9LMQ" 
              frameborder="0" 
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" 
              allowfullscreen="">
            </iframe>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { reactive } from 'vue';

export default {
  setup() {
    const state = reactive({
      root_url: process.env.VUE_APP_ENDPOINT
    });

    return {
      state
    }
  }
}
</script>